import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/****************  GET PARTICULAR MEMBER LOAN CARD START ********************** */
export const memberLoanCardReport = (listData: any) => {
	const data = {
		GetLoanDetailsForParticularMemberToken: listData,
	};
	const url = `${API_URL}getParticularMemberLoanDetails`;
	return makeApiCall(url, data);
};
/****************  GET PARTICULAR MEMBER LOAN CARD END ********************** */
